import Axios from "axios";
import * as serviceURL from "./service-url";

export const getAllRechargeBeneficiaryList = (request = {}, headers = {}, params = {}) => {
  return Axios.post(serviceURL.getAllRechargeBeneficiaryList, request, { headers: headers, params: params });
};

